"use client";

import { createContext, useContext, type ReactNode } from "react";
import { AI_NAME } from "./theme-config";

const AppNameContext = createContext<string>(AI_NAME);

export function AppNameProvider({
  appName,
  children,
}: {
  appName: string;
  children: ReactNode;
}) {
  return (
    <AppNameContext.Provider value={appName}>{children}</AppNameContext.Provider>
  );
}

export function useAppName() {
  return useContext(AppNameContext);
}
